module.exports = __webpack_public_path__ + "8233e12f068dbda77a903cc4d697697e.svg";